export class Calltime {
    value: string;
    text: string;
}
